export default __webpack_public_path__ + "static/betql-full-width-1-a70f1a1f4d35fa3966ae2485763e1ffe.avif";